import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SpaceContext = createContext({
  activeSpace: null,
  spaces: [],
  setActiveSpace: () => {},
  loadSpaces: async () => {},
  spacesLoading: false,
});

export function SpaceProvider({ children }) {
  const [activeSpace, setActiveSpaceState] = useState(() => {
    try {
      const stored = localStorage.getItem('kurso_active_space');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const [spaces, setSpaces] = useState(() => {
    try {
      const stored = localStorage.getItem('kurso_spaces');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const [spacesLoading, setSpacesLoading] = useState(false);

  const _cacheSpaces = (list) => {
    try { localStorage.setItem('kurso_spaces', JSON.stringify(list)); } catch {}
  };

  const setActiveSpace = (space) => {
    setActiveSpaceState(space);
    if (space) {
      localStorage.setItem('kurso_active_space', JSON.stringify(space));
    } else {
      localStorage.removeItem('kurso_active_space');
    }
  };

  const loadSpaces = useCallback(async () => {
    setSpacesLoading(true);
    try {
      const { data } = await axios.get(`${API}/spaces/mine`, { withCredentials: true });
      const list = data || [];
      setSpaces(list);
      _cacheSpaces(list);
      // Invalidate active space if no longer member
      setActiveSpaceState(prev => {
        if (!prev) return prev;
        const still = list.find(s => s.id === prev.id);
        if (!still) {
          localStorage.removeItem('kurso_active_space');
          return null;
        }
        return prev;
      });
    } catch {
      // Keep cached spaces on API error — do not clear the list
    } finally {
      setSpacesLoading(false);
    }
  }, []);

  return (
    <SpaceContext.Provider value={{ activeSpace, spaces, setActiveSpace, loadSpaces, spacesLoading }}>
      {children}
    </SpaceContext.Provider>
  );
}

export const useSpace = () => useContext(SpaceContext);
